<template>
    <v-snackbar v-model="show" :timeout="-1" :transition="false" :class="animate ? 'animate__animated animate__shakeX animate__infinite' : undefined" v-show="!$store.state.missingMemberFields.disabled" color="primary">
        <span class="primarytext--text">{{$translate('We are missing your card details')}}</span>

        <template v-slot:action="{ attrs }">
            <v-btn
                text
                v-bind="attrs"
                class="zoezi-button-thin primarytext--text"
                @click="showDialog = true"
            >
                {{$translate('Fill in now')}}
            </v-btn>
        </template>

         <v-dialog v-model="showDialog" max-width="500px" scrollable :persistent="persistentDialog" v-if="$store.state.user">
             <v-card>
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        {{$translate('Add card details')}}
                        <v-btn v-if="!persistentDialog" icon @click="showDialog = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="my-4">
                        {{$translate('You have upcoming payments that will be taken from your credit card. You need to update your card information and add a credit card for the withdrawal to succeed.')}}
                    </div>
                    <my-payment-methods :show-value-card="false" :show-cards="true" :show-direct-debit="false"/>
                </v-card-text>
             </v-card>
         </v-dialog>
    </v-snackbar>
</template>

<script>
import MyPaymentMethods from '../views/MyPaymentMethods.vue'
export default {
    name: 'zoezi-save-card-dialog',

    watch: {
        '$store.state.user': {
            immediate: true,
            handler(user) {
                if (!user) {
                    return;
                }

                const needToSaveCard = user.hasPendingCardPayments && !user.savedCard;
                this.show = needToSaveCard;
                this.showDialog = needToSaveCard;
            }
        }
    },

    components: {
        MyPaymentMethods,
    },

    data: () => ({
        show: false,
        animate: false,
        timeout: null,
        showDialog: false,
        persistentDialog: false
    }),

    methods: {
        refetchUser() {
            this.$api.get('/api/memberapi/get/current').then(user => {
                this.$store.commit('setUserData', {user})
            });
        }
    },

    mounted() {
        this.$api.subscribe({type: 'payment', callback: () => {
            if (this.show) {
                this.refetchUser();
            }
        } });
    }
}
</script>
